import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30s avant qu’une query ne soit considérée "périmée"
      refetchOnWindowFocus: false,
      retry: 1, // nombre de retries si erreur
    },
    mutations: {
      retry: 0,
    },
  },
});
